import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Nav from './Components/Nav';
import About from './Components/About';
import Contact from './Components/Contact';
import Services from './Components/Services';
import Home from './Components/Home';
import Footer from './Components/Footer';


function App() {
  return (
    <BrowserRouter>
      <Nav />
      <Routes >
        <Route path='/' element={<Home />}/>
        <Route path='/about' element={<About />}/>
        <Route path='/contact' element={<Contact />}/>
        <Route path='/services' element={<Services />}/>
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
